/* ConditionalFormattingComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ConditionalFormattingRenderer");

class ConditionalFormattingComponent extends EventEmitter {
    constructor(logger, userSession, modalUserFeedback, item, TemplateEntity, isOwner) {
        super();
        this._titleText = "Conditional Formatting";
        this._logger = logger;
        this._userSession = userSession;
        this._modalUserFeedback = modalUserFeedback;
        this._currentItem = item;
        this._templateEntity = TemplateEntity;
        this._isOwnUser = isOwner;

        this._fieldType = _.get(this._currentItem.solutions, `${this._currentItem.field.replaceAll(">", ".")}.dataType`, this._currentItem.dataType);
        this._fieldName = _.get(this._currentItem, "field", "");
        this._columnTitle = _.get(this._currentItem, "heading", _.get(this._currentItem, "dheading"));
        if (this._fieldType === "duration") {
            this._columnTitle += " (hours)";
        }

        if (this._fieldType === "enum") {
            const enumInfo = _.get(
                this._currentItem.solutions,
                `${this._currentItem.field.replaceAll(">", ".")}.typeInfo`,
                this._currentItem.typeInfo
            ) || {
                ids: [],
                labels: []
            };
            this._enumValues = enumInfo.ids.map((id, idx) => {
                return {
                    text: enumInfo.labels[idx],
                    value: id
                };
            });
        }

        this._conditionalData = [];
        this._rowIndex = 0;

        this._renderer = new Renderer(this);
        this.reject = this.reject.bind(this);
        this.resolve = this.resolve.bind(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "CaptureNameComponent.shutdown() error");
            }
        );
    }

    cancelAction() {
        let err = new Error("user rejected");
        err.userRejected = true;
        return this.reject(err);
    }

    reject(err) {
        this._context.reject(err);
    }
    resolve(action) {
        this._context.resolve(action);
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    saveNewQuery(value) {
        this._parentRenderer
            .saveNewQuery(value, this._formData)
            .then(() => {
                this.cancelAction();
            })
            .catch((err) => {
                this.logger.warn(err);
                this.emit("error", err);
            });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ConditionalFormattingComponent;
